var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreationCard5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333496,
    width: 40,
    height: 40,
    rx: 16,
    fill: "#8B5CF6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9336 28.4C11.9336 28.0818 12.06 27.7765 12.2851 27.5515C12.5101 27.3265 12.8153 27.2 13.1336 27.2H27.5336C27.8519 27.2 28.1571 27.3265 28.3821 27.5515C28.6072 27.7765 28.7336 28.0818 28.7336 28.4C28.7336 28.7183 28.6072 29.0235 28.3821 29.2486C28.1571 29.4736 27.8519 29.6 27.5336 29.6H13.1336C12.8153 29.6 12.5101 29.4736 12.2851 29.2486C12.06 29.0235 11.9336 28.7183 11.9336 28.4ZM15.8852 19.1516C16.1102 18.9267 16.4154 18.8003 16.7336 18.8003C17.0518 18.8003 17.357 18.9267 17.582 19.1516L19.1336 20.7032V11.6C19.1336 11.2818 19.26 10.9765 19.4851 10.7515C19.7101 10.5265 20.0153 10.4 20.3336 10.4C20.6519 10.4 20.9571 10.5265 21.1821 10.7515C21.4072 10.9765 21.5336 11.2818 21.5336 11.6V20.7032L23.0852 19.1516C23.1959 19.037 23.3283 18.9456 23.4747 18.8827C23.6211 18.8198 23.7786 18.7867 23.9379 18.7853C24.0972 18.7839 24.2553 18.8143 24.4027 18.8746C24.5502 18.935 24.6842 19.0241 24.7969 19.1368C24.9095 19.2494 24.9986 19.3834 25.059 19.5309C25.1193 19.6784 25.1497 19.8364 25.1483 19.9957C25.1469 20.155 25.1138 20.3125 25.0509 20.4589C24.988 20.6053 24.8966 20.7377 24.782 20.8484L21.182 24.4484C20.957 24.6734 20.6518 24.7998 20.3336 24.7998C20.0154 24.7998 19.7102 24.6734 19.4852 24.4484L15.8852 20.8484C15.6602 20.6234 15.5338 20.3182 15.5338 20C15.5338 19.6818 15.6602 19.3767 15.8852 19.1516Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreationCard5);
export default __webpack_public_path__ + "static/media/creation-card-5.b3ea57b2d15fbe0503433232ba6d6a2f.svg";
export { ForwardRef as ReactComponent };